import apiClient from './apiClient';

/**
 * @summary Service for getting Acumatica prices
 */
export class AcumaticaPriceService {
  /**
   * @summary Get Acumatica prices for a category code
   * 
   * @param {string} catCode The category code to get prices for
   * @returns {Promise<{
   *   date: "2021-01-01",
   *   catCode: "CAT-12345",
   *   BasePrice: "123.45",
   *   OverstockPrice: "123.45"
   * }[]>}
   */
  async getAcumaticaPrices(catCode) {
    const response = await apiClient.getWithCache(`api/acumaticaPrice/${catCode}`);
    return response.data;
  }
}
